module.exports = __webpack_public_path__ + "img/hzfp7.23728409.png";